import { render, staticRenderFns } from "./ConfigureForm.vue?vue&type=template&id=c09fe0c0&scoped=true&"
import script from "./ConfigureForm.vue?vue&type=script&lang=ts&"
export * from "./ConfigureForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigureForm.vue?vue&type=style&index=0&id=c09fe0c0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09fe0c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c09fe0c0')) {
      api.createRecord('c09fe0c0', component.options)
    } else {
      api.reload('c09fe0c0', component.options)
    }
    module.hot.accept("./ConfigureForm.vue?vue&type=template&id=c09fe0c0&scoped=true&", function () {
      api.rerender('c09fe0c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/ConfigureForm.vue"
export default component.exports